import { Cloudinary } from "cloudinary-core";
import React from "react";
import styled from "styled-components/macro";
import { color } from "styled-system";
import Image, {
  AspectRatio,
  getVariant,
  fragment as ImageFragment
} from "../../components/Image";
import { gql } from "apollo-boost";

const cloudinary = new Cloudinary({ cloud_name: "unserwein" });

const ProducerAspectRatio = styled(AspectRatio)`
  ${color}
  background-position: 50% 25%;
  background-size: cover;
  @supports (object-fit: cover) {
    min-height: calc(160px - ${props => 100 / props.aspectRatio}vw);
  }
`;

const ProducerHeaderImage = styled(Image)`
  display: block;
  @supports (object-fit: cover) {
    object-fit: cover;
    min-height: 160px;
  }
`;
ProducerHeaderImage.defaultProps = { variant: "header" };
export default function HeaderImage({ image = {} }) {
  if (!image) return null;
  const publicId = image.publicId;
  if (!publicId) return null;

  const url =
    publicId &&
    cloudinary.url(publicId, {
      ...getVariant({ ...image, variant: "header" }),
      dpr: "2.0",
      width: 16
    });
  return (
    <ProducerAspectRatio
      aspectRatio={4 / 1}
      bg="soft.0"
      style={url && { backgroundImage: `url(${url})` }}
    >
      <ProducerHeaderImage {...image} />
    </ProducerAspectRatio>
  );
}

export const fragment = gql`
  fragment HeaderImage on Image {
    ...Image
  }
  ${ImageFragment}
`;
